module.exports = __webpack_public_path__ + "static/media/DSC_0864.e7d0d1e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0864.jpg
// module id = 605
// module chunks = 0